import { postProviderSessionRequest } from '@/services/api/requests/providers';
import { useMutation } from '@tanstack/react-query';

const useProviderSessionRequest = (therapistId: string, onSuccessCallback: () => void) => {
  const { isSuccess, isPending, mutate, error } = useMutation({
    mutationFn: async () => {
      const response = await postProviderSessionRequest(therapistId);
      return response;
    },
    onSuccess: () => {
      if (onSuccessCallback) {
        onSuccessCallback();
      }
    },
    onError: () => {},
  });

  return { isPending, isSuccess, mutate, error };
};

export default useProviderSessionRequest;
